import React,{useRef, useState} from 'react'
import { Form , Button , Card, Alert } from 'react-bootstrap'
import { Container } from 'react-bootstrap'
import { useAuth } from 'contexts/authContext'
import { Link, useHistory } from 'react-router-dom'
import Background from 'assets/img/cd.jpg';
// import Background1 from 'assets/img/b.jpg';

export default function Signup() {


  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  // const {signup, currentUser } = useAuth()
  const {signup } = useAuth()
  const [error,setError] = useState('')
  const [loading ,setLoading] = useState(false)
  const history  = useHistory()

async function handleSubmit(e){
    e.preventDefault()
  
    if(passwordRef.current.value !== passwordConfirmRef.current.value){

      return setError('Passwords do not match')

    }

    try{

      setError('')
      setLoading(true)
      await signup(emailRef.current.value, passwordRef.current.value)
      history.push("/")

    }catch{
       setError('failed to create an account')
    }
    setLoading(false)
}


var sectionStyle = {
  // width: "100%",
  // height: "100%",
  backgroundSize: 'cover', 
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${Background})`
};

// var sectionStyle1 = {
//   width: "100%",
//   height: "100%",
//   backgroundImage: `url(${Background1})`
// };


    return (
        <>
            
  <section style={ sectionStyle }>

        <container
        className = "d-flex align-items-center justify-content-center"
        style = {{minHeight: "100vh"}}
        >
            <div className="w-100" style = {{maxWidth:'420px'}}>
    
            <Card style={{ width: '28rem' }}>
            {/* <section style={ sectionStyle1 }  > */}
            
        <Card.Body>
          <h2 className="text-center mb-4">Sign Up</h2>
          {/* {currentUser.email} */}
          {error && <Alert variant="danger">{error}</Alert>}
          <Form  onSubmit={handleSubmit} >
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" ref={passwordRef} required />
            </Form.Group>
            <Form.Group id="password-confirm">
              <Form.Label>Password Confirmation</Form.Label>
              <Form.Control type="password" ref={passwordConfirmRef} required />
            </Form.Group>
           
           <br></br>

            <Button disabled={loading} className="w-100" type="submit">
              Sign Up
            </Button>
            
          </Form>
          <br></br>
          <div className="w-100 text-center mt-2">
      Already have an account? <Link to="/login">Login</Link>
      </div>
      <br></br>
        </Card.Body>
        {/* </section> */}
      </Card>
    
      </div>      
      </container>

      </section>
        </>
    )
}
